import { Box, Container, Typography, Divider, Stack } from "@mui/material";
import { Loading } from "src/components/utils/Loading";
import { useApplicationParameters } from "src/api/client-api/appParams";
import { Theme } from "./Fields/Theme";
import { Mode } from "./Fields/Mode";
import { BaseIconUpload } from "./BaseIconUpload";
import { BaseStringUpload } from "./BaseStringUpload";
import { BaseToggleUpload } from "./BaseToggleUpload";
import { ActionPlanModal } from "./ExtraConfiguration/ActionPlanModal";
import { useState } from "react";

export const AppParamsSettings = () => {
    const { applicationParameters } = useApplicationParameters();

    if (applicationParameters === undefined) return <Loading />;
    const [isActionPlanModalOpen, setActionPlanModalOpen] = useState(false);

    return (
        <Container
            component="main"
            maxWidth={false}
            sx={{
                m: "0",
                p: "5rem !important",
            }}
        >
            <Typography variant="h1">Paramètres</Typography>
            <Typography variant="big-bold">Please, validate your changes one field at a time.</Typography>
            <Box sx={{ py: 2 }} />
            <Divider />
            <Box sx={{ py: 2 }} />

            <Stack gap={"30px"}>
                <Theme currentTheme={applicationParameters.theme ?? null} />
                <Mode currentMode={applicationParameters.mode ?? null} />
                <BaseToggleUpload
                    appParamKey="dx-ux-testing"
                    label="Lucie Design System testing flag -- EXPERIMENTAL - ALL PAGES WILL CHANGE FOR EVERYONE IF TRIGGERED"
                />
                <Divider />
                <BaseStringUpload
                    label={"Title of the tab"}
                    description={"This appears on the very top of your browser"}
                    appParamKey={"tabTitle"}
                />
                <Divider />
                <Stack flexDirection={"row"} gap={"75px"}>
                    <BaseIconUpload
                        label={"Fav icon"}
                        description={"This represents the Icon of your tab, and in your favorites"}
                        appParamKey={"tabIcon"}
                    />
                    <BaseIconUpload
                        label={"Footer"}
                        description={"Image used to the far-left of the footer - Size is FIXED in the footer"}
                        appParamKey={"footerLogo"}
                    />
                    <BaseIconUpload
                        label={"PDF Front Cover Image"}
                        description={"A4-format image displayed on the front cover of the PDF"}
                        appParamKey={"front_cover_pdf"}
                    />
                </Stack>
                <Divider />
                <BaseStringUpload
                    label={"Freshdesk Widget ID"}
                    description={"ID of the Freshdesk window that appears on the screen"}
                    appParamKey="freshdeskWidgetId"
                />
                <Divider />
                <BaseToggleUpload
                    appParamKey={"FS-homepage"}
                    label={"Page homepage"}
                    description={"Feature switch of Homepage"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-puck-homepage"}
                    label={"Page Puck homepage"}
                    description={
                        "Feature switch of Puck Homepage,\
                         be careful if the Homepage feature is activated the Puck edition will be added next to the Classic homepage content"
                    }
                />
                <BaseToggleUpload
                    appParamKey={"FS-strategy"}
                    label={"Page stratégie"}
                    description={"Feature switch of Stratégie"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-score-details-comparison"}
                    label={"Page Diagnostic: Score > Comparison"}
                    description={"Feature switch of Comparaison module"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-score-details-distribution"}
                    label={"Page Diagnostic: Score > Distribution"}
                    description={"Feature switch of Distribution module"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-actionPlan"}
                    label={"Page Action Plan"}
                    description={"Feature switch of Action Plan module"}
                    extraConfiguration={() => {
                        setActionPlanModalOpen(true);
                    }}
                />
                <BaseToggleUpload
                    appParamKey={"FS-ssq-export-excel"}
                    label={"Export SSQ content as Excel"}
                    description={"Feature switch of export SSQ content as Excel module"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-collective-pdf-export"}
                    label={"Collective Pdf export"}
                    description={"Feature switch of collective Pdf export module"}
                />
                <BaseToggleUpload
                    label={"EVEA Askor"}
                    description={"Feature switch of link to external EVEA Askor platform"}
                    appParamKey="FS-evea-askor"
                />
                <BaseToggleUpload
                    appParamKey={"FS-collective-assessment-pdf-export"}
                    label={"Collective Assessment Pdf export"}
                    description={"Feature switch of collective Assessment Pdf export module"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-legal-requirement"}
                    label={"Legal Requirements"}
                    description={"Feature switch for the legal requirements section in company page"}
                />
                <ActionPlanModal isOpen={isActionPlanModalOpen} setOpen={setActionPlanModalOpen} />
            </Stack>
            <Box sx={{ py: 2 }} />
        </Container>
    );
};
